import { render } from "./MySpent.vue?vue&type=template&id=09bf37c5&scoped=true"
import script from "./MySpent.vue?vue&type=script&lang=js"
export * from "./MySpent.vue?vue&type=script&lang=js"

import "./MySpent.vue?vue&type=style&index=0&id=09bf37c5&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09bf37c5"]])

export default __exports__